import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
		pageLoading: true, //加载动画
		dialogData: null, //弹框数据
		userinfo: null,  // 用户信息
		aid: '' // 活动id
    },
    mutations: {
		setPageLoading(state, flag) {
			state.pageLoading = flag
		},
		setDialogData(state, data) {
			state.dialogData = data
		},
		setUserinfo(state, data) {
			if(typeof data == 'string') data = JSON.parse(data);
			state.userinfo = data;
		},
		setAid(state, data) {
			state.aid = data;
		},
    },
    actions: {
        setPageLoadingAsync({ commit, state }, flag) {
          	commit('setPageLoading', flag)
		},
		setDialogDataAsync({ commit, state }, data) {
			commit('setDialogData', data)
		},
		
    }
})
